import { Suspense } from "react";
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import { MANUALS } from "../../manuals";

export default function ManualViewerDialog({ open, onClose, manualKey }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isDark = theme.palette.mode === "dark";

  const manual = MANUALS[manualKey];
  if (!manual) return null;

  const ManualComponent = manual.component;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isMobile}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 4,
          height: isMobile ? "100%" : "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          background: isDark ? "rgba(15,23,42,0.98)" : "#fafafa",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: 2.5,
          height: 54,
          flexShrink: 0,
          borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.07)"}`,
          background: isDark ? "rgba(25,118,210,0.08)" : "rgba(25,118,210,0.04)",
        }}
      >
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: 2,
            display: "grid",
            placeItems: "center",
            flexShrink: 0,
            background: isDark ? "rgba(25,118,210,0.12)" : "rgba(255,255,255,0.72)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(47,147,247,0.22)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            color: "primary.main",
            "& svg": { fontSize: 20, display: "block" },
          }}
        >
          <MenuBookRoundedIcon />
        </Box>
        <Typography sx={{ fontWeight: 800, fontSize: 15, flex: 1 }}>
          {manual.title}
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ borderRadius: 2 }}>
          <CloseRoundedIcon sx={{ fontSize: 19 }} />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
        <Suspense
          fallback={
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
              <CircularProgress size={32} />
            </Box>
          }
        >
          <ManualComponent />
        </Suspense>
      </Box>
    </Dialog>
  );
}
